import { render, staticRenderFns } from "./project-role.vue?vue&type=template&id=dd0e51e8"
import script from "./project-role.vue?vue&type=script&lang=js"
export * from "./project-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports